import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, getTeamLineup, assetUrl } from "../../lib/api";
import { CompactLineup } from "../NhlGameCentrePanel";

// PWHL side board: the team's CURRENT ACTIVE lineup (Team → Lineup), for early predictions.
export function PwhlSideLineup({ team, sideLabel }) {
    const tid = team?.id;
    const { data: lineup } = useQuery({ queryKey: ["team-lineup", tid], queryFn: () => getTeamLineup(tid), enabled: !!tid, staleTime: 60 * 1000 });
    const { data: players = [] } = useQuery({ queryKey: ["players-by-team", tid], queryFn: () => api.get("/players", { params: { team_id: tid } }).then((r) => r.data?.players || r.data || []), enabled: !!tid, staleTime: 5 * 60 * 1000 });
    const playerMap = useMemo(() => {
        const m = {};
        players.forEach((p) => { m[p.id] = { photo_url: p.photo_url, jersey: p.jersey, position: p.position, pref_position: p.pref_position || p.position, name: p.name, captain: p.captain, photo_x: p.photo_x, photo_y: p.photo_y, photo_zoom: p.photo_zoom }; });
        return m;
    }, [players]);
    const color = team?.primary_color || "#9D4CDD";
    const head = (
        <div className="w-full rounded-xl border px-2.5 py-2 min-w-0 flex flex-col justify-center gap-1" style={{ background: `linear-gradient(135deg, ${color}40, transparent 70%)`, borderColor: `${color}80` }}>
            <div className="flex items-center gap-2 min-w-0">
                {team?.logo_url && <img src={assetUrl(team.logo_url)} alt={team.abbr} className="h-8 w-8 object-contain shrink-0" />}
                <div className="min-w-0">
                    <div className="text-[13px] font-black uppercase text-white leading-none">{team?.abbr || tid}</div>
                    <div className="text-[9px] text-white/55 leading-tight truncate">{team?.name || tid}</div>
                </div>
            </div>
            <div className="text-[9px] font-black uppercase tracking-wider text-white/45 truncate">{sideLabel} · Active lineup</div>
        </div>
    );
    return (
        <div data-testid={`pwhl-side-lineup-${tid}`}>
            {lineup ? <CompactLineup side head={head} hideSource lineup={lineup} playerMap={playerMap} accent={color} editable={false} pool={players} autoScratch={[]} teamAbbr={team?.abbr} />
                : <><div className="mb-2">{head}</div><div className="py-6 text-center text-white/40 text-xs rounded-xl border border-white/10">Loading lineup…</div></>}
        </div>
    );
}
